<template>
    <div>
      <div class="wrapper">
        <van-icon size="180" name="close" color="#ee0a24" style="margin: 50px auto" />
      </div>
      <div class="van-ellipsis" style="text-align:center; font-size:23px; margin-bottom:50px"> Oturum Sonlandırılmış.</div>

      <van-button type="danger" block size="small" @click="$helper.logout" > GÜVENLİ ÇIKIŞ </van-button>
      
    </div>
</template>

<script>
export default {
  components:{},
  data() {
    return {
    };
  },
  created (){
    this.$store.dispatch('setMenu',false)
    this.$store.commit("setLoading",[false,'...'])    
  },

  methods : {
    depo(){
      this.$notify({ type: 'success', message: 'Standart Depo'});
    }
  }
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/oturum.vue